var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",style:({background: _vm.color}),attrs:{"data-size":_vm.size}},[_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.letters))])])}
var staticRenderFns = []

export { render, staticRenderFns }